module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--de-8a02e2c179e59d836f3d18120951be61.jpg";